/**
 * Marks a message as coming from the shared callback page. Lives here because the page that
 * emits it — `oauth-callback.html`, in this folder — is the other half of the contract, and an
 * opener that listens for anything else silently never completes its sign-in.
 */
export const OAUTH_MESSAGE_SOURCE = 'instaclause-oauth';

/** Path the shared callback page is served from. Register this with each OAuth provider. */
export const OAUTH_CALLBACK_PATH = '/oauth-callback.html';

/** Absolute URL of the shared callback page, to send as `redirect_uri`. */
export function oauthCallbackUrl(): string {
  return window.location.origin + OAUTH_CALLBACK_PATH;
}
